import { useEffect, useRef } from "react";

/** Native checkbox with support for the indeterminate (partially selected) state. */
export default function DataTableCheckbox({ checked, indeterminate = false, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      aria-checked={indeterminate && !checked ? "mixed" : checked}
      className="h-4 w-4 cursor-pointer rounded border-app-primary bg-app-input text-blue-600 focus:ring-2 focus:ring-blue-500/40 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50"
      {...rest}
    />
  );
}
